import Vue from 'vue'

function mostrarModalAutonomo(router) {
  Vue.swal({
    title: '<div style="color:#ed7d3e;">🚀 O Monitor Autônomo chegou trazendo mais liberdade na sua rotina!</div>',
    html: `
      <div style="color:rgb(25, 48, 81); font-size: 18px;">
        <br>
        Olá!
        <br><br>
        Com o Monitor Autônomo, os envios de documentos passam a acontecer de forma automática, direto para o cliente e sem necessidade de intervenção manual da sua equipe.
        <br><br>
        Você define o documento, configura a data do envio e o Monitor executa a rotina sozinho, todos os meses. Mais agilidade para o escritório, menos tarefas operacionais e menos risco de esquecimentos na entrega ao cliente.
        <br><br>
        A configuração já está disponível e leva poucos minutos.
        <br><br>
        <b>Clique em "Configurar" para acessar o Monitor Autônomo.</b>
        <br><br>
        <b>Atenciosamente, Equipe Monitor Contábil</b>
      </div>
    `,
    icon: 'warning',
    iconColor: '#ed7d3e',
    confirmButtonText: 'Configurar',
    showCancelButton: true,
    cancelButtonText: 'Fechar',
    reverseButtons: false,
    buttonsStyling: false,
    width: '35%',
    customClass: {
      popup: 'swal-m',
      confirmButton: 'btn btn-primary mt-2 mr-2',
      cancelButton: 'btn btn-danger mt-2 ml-2',
    },
  }).then(result => {
    if (result.isConfirmed) {
      router.push({ name: 'envio-automatico' })
    }
  })
}

// eslint-disable-next-line no-unused-vars
export default function (router) {
  const hoje = new Date()
  const fimAviso = new Date('2026-06-23T23:59:59')

  if (hoje <= fimAviso) {
    Vue.swal({
      title: '<div style="color:#ed7d3e;">⚠️ AVISO SOBRE ATENDIMENTO</div>',
      html: `
        <div style="color:rgb(25, 48, 81); font-size: 16px; text-align: left;">
          <br>
          Entre os dias 22 e 23, nosso atendimento será realizado exclusivamente pelos e-mails e telefone:
          <br><br>
          &bull; +55 11 91339-7304<br>
          &bull; rebeca.abreu@monitorcontabil.com.br<br>
          &bull; ouvidoria@monitorcontabil.com.br<br>
          &bull; abdiel.barbosa@monitorcontabil.com.br
          <br><br>
          Durante esse período, solicitamos que todas as solicitações, dúvidas e demandas de suporte sejam direcionadas para esses contatos.
          <br><br>
          Para tratar de assuntos relacionados a financeiro, utilize também os contatos acima ou o e-mail:
          <br><br>
          &bull; financeiro@monitorcontabil.com.br
          <br><br>
          ⏰ <b>Horário de atendimento:</b><br>
          De segunda a sexta-feira, das 08h30 às 18h.
          <br><br>
          Agradecemos a compreensão.
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'Entendi',
      buttonsStyling: false,
      width: '35%',
      customClass: {
        popup: 'swal-m',
        confirmButton: 'btn btn-primary mt-2',
      },
    }).then(() => mostrarModalAutonomo(router))
  } else {
    mostrarModalAutonomo(router)
  }
}
